import { axiosInstance } from '@/lib/axios';
import { CountriesConfigurationResponse } from './types';

type Props = {
  companyId: string
}

export function getCountriesSettings({ companyId }: Props) {
  return axiosInstance.get<CountriesConfigurationResponse>(`/api/${companyId}/configuration/country`);
}
